import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CompanyService } from '@app/services';
import { Toaster } from '@services/index';
import { Product, PurchaseOrderDto, Step } from '@models/index';
import { LocalStorage } from 'ngx-webstorage';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ngx-steps-to-produce-detail',
  templateUrl: './steps-to-produce-detail.component.html',
  styleUrls: ['./steps-to-produce-detail.component.scss'],
})
export class StepsToProduceDetailComponent implements OnInit, OnChanges {
  @Input() purchaseOrder: PurchaseOrderDto;

  @LocalStorage() organizationId: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private $company: CompanyService,
    public location: Location,
    private $toaster: Toaster,
  ) { }

  async ngOnInit() {
  }

  async ngOnChanges(changes: SimpleChanges) {
  }

  async getSteps(item) {
    item.loading = true;
    this.$company.lineItemSteps(this.organizationId, item.id)
      .subscribe((steps: any) => {
        item.steps = steps.slice().sort((a, b) => a.sequence_number - b.sequence_number);
        item.loading = false;
      });
  }

  setStepProgress($event, lineItemID: string, step: Step) {
    let qty: number;
    try {
      const parsed = parseInt($event.srcElement.value);
      if (isNaN(parsed)) {
        throw new Error("provided value is not a number");
      }
      if (parsed < 0) {
        throw new Error("negative values are not allowed");
      }
      qty = parsed;
    } catch (err) {
      console.log(err);
      $event.srcElement.value = step.quantity;
      this.$toaster.show('error', 'Error', 'Please provide a valid value.');
      return;
    }

    this.$company.updateStepProgress(lineItemID, step.id, qty)
      .subscribe(res => {
        this.$toaster.show('success', 'Success', 'You changes were saved.');
      }, error => {
        console.log(error);
        this.$toaster.show('error', 'Error', 'It was not possible to update the quantity for this step, please try again later.');
      });
  }

}
